/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Aaf_Embed_Self_ContainedInputs */

const en_subtitle_export_aaf_embed_self_contained = /** @type {(inputs: Subtitle_Export_Aaf_Embed_Self_ContainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF Embed (Self Contained)`)
};

const fr_subtitle_export_aaf_embed_self_contained = /** @type {(inputs: Subtitle_Export_Aaf_Embed_Self_ContainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF Embed (Autonome)`)
};

const de_subtitle_export_aaf_embed_self_contained = /** @type {(inputs: Subtitle_Export_Aaf_Embed_Self_ContainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF-Einbettung (eigenständig)`)
};

const it_subtitle_export_aaf_embed_self_contained = /** @type {(inputs: Subtitle_Export_Aaf_Embed_Self_ContainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF Embed (autosufficiente)`)
};

const ru_subtitle_export_aaf_embed_self_contained = /** @type {(inputs: Subtitle_Export_Aaf_Embed_Self_ContainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF Embed (автономный)`)
};

const es_subtitle_export_aaf_embed_self_contained = /** @type {(inputs: Subtitle_Export_Aaf_Embed_Self_ContainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integración de AAF (autónoma)`)
};

const zh_cn2_subtitle_export_aaf_embed_self_contained = /** @type {(inputs: Subtitle_Export_Aaf_Embed_Self_ContainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF嵌入式（独立式）`)
};

const ja_subtitle_export_aaf_embed_self_contained = /** @type {(inputs: Subtitle_Export_Aaf_Embed_Self_ContainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AAF埋め込み（自己完結型）`)
};

const hi_subtitle_export_aaf_embed_self_contained = /** @type {(inputs: Subtitle_Export_Aaf_Embed_Self_ContainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एएएफ एम्बेड (स्वयं-निहित)`)
};

const pt_pt2_subtitle_export_aaf_embed_self_contained = /** @type {(inputs: Subtitle_Export_Aaf_Embed_Self_ContainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporação AAF (Autocontida)`)
};

/**
* | output |
* | --- |
* | "AAF Embed (Self Contained)" |
*
* @param {Subtitle_Export_Aaf_Embed_Self_ContainedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_aaf_embed_self_contained = /** @type {((inputs?: Subtitle_Export_Aaf_Embed_Self_ContainedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Aaf_Embed_Self_ContainedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_aaf_embed_self_contained(inputs)
	if (locale === "de") return de_subtitle_export_aaf_embed_self_contained(inputs)
	if (locale === "it") return it_subtitle_export_aaf_embed_self_contained(inputs)
	if (locale === "ru") return ru_subtitle_export_aaf_embed_self_contained(inputs)
	if (locale === "es") return es_subtitle_export_aaf_embed_self_contained(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_aaf_embed_self_contained(inputs)
	if (locale === "ja") return ja_subtitle_export_aaf_embed_self_contained(inputs)
	if (locale === "hi") return hi_subtitle_export_aaf_embed_self_contained(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_aaf_embed_self_contained(inputs)
	return en_subtitle_export_aaf_embed_self_contained(inputs)
});